'use client';

import type { ReactNode } from 'react';
import { createContext, useContext, useState, useEffect } from 'react';
import { getPromoCode } from '@repo/utils/localStorageUtils';
import type { PaymentStoreContextState, PaymentStoreProps } from './paymentStore';
import { defaultPaymentStoreState } from './paymentStore';
import { getPricingPlans } from './actions';

const StoreContext = createContext(defaultPaymentStoreState);

export const usePaymentStore = <T = PaymentStoreContextState,>(
    selector: (state: PaymentStoreContextState) => T = (state) => state as unknown as T,
): T => {
    const state = useContext(StoreContext);

    return selector(state);
};

export default function PaymentStoreContext({
    children,
    paymentCart: initialPaymentCart,
}: {
    children: ReactNode;
    paymentCart?: PaymentStoreProps;
}) {
    const [paymentCart, setPaymentCart] = useState(initialPaymentCart || []);

    return (
        // @ts-expect-error
        <StoreContext.Provider value={{ paymentCart, setPaymentCart }}>
            {children}
        </StoreContext.Provider>
    );
}
